export const NoteEditorMenu = {
  props: {
    commands: {
      type: Object,
      required: true
    },
    getMarkAttrs: {
      type: Function,
      required: true
    },
    isActive: {
      type: Object,
      required: true
    },
    options: {
      type: Array,
      default: () => []
    },
    visibleOptions: {
      type: Number,
      default: 10
    }
  },
  data () {
    return {
      isLinkDialogOpen: false,
      isMoreTextFormattingOptionsVisible: false,
      form: {
        url: null
      }
    }
  },
  computed: {
    textFormattingOptions () {
      // Display full formatting options if total options is less or equals than permissible visible options
      // Display one item less than permissible visible options, plus the more options icon.
      const lastPosition = this.options.length <= this.visibleOptions ? this.visibleOptions : this.visibleOptions - 1
      return this.options.slice(0, lastPosition)
    },
    moreTextFormattingOptions () {
      const firstPosition = this.options.length <= this.visibleOptions ? this.visibleOptions : this.visibleOptions - 1
      return this.options.slice(firstPosition)
    }
  },
  methods: {
    executeTextFormatFunction (formatOption, formatFunction) {
      return formatOption.attrs ? formatFunction[formatOption.name](formatOption.attrs) : formatFunction[formatOption.name]()
    },
    formatText (formatOption) {
      if (formatOption.name === 'link') {
        const url = this.getMarkAttrs('link').href
        this.openLinkDialog(url)
        return
      }
      this.executeTextFormatFunction(formatOption, this.commands)
      this.isMoreTextFormattingOptionsVisible = false
    },
    isTextFormattingOptionActive (formatOption) {
      if (formatOption.inactive) {
        // For any extension which do not have isActive value, we will need to return false by default.
        // e.g. history extension, undo and redo command.
        return false
      }
      return this.executeTextFormatFunction(formatOption, this.isActive)
    },
    isMoreTextFormattingOptionsActive () {
      return this.moreTextFormattingOptions.some(
        formatOption => this.isTextFormattingOptionActive(formatOption)
      )
    },
    openLinkDialog (url) {
      if (url) {
        this.form.url = url
      }
      this.isLinkDialogOpen = true
    },
    closeLinkDialog () {
      this.form.url = null
      this.isLinkDialogOpen = false
    },
    setLinkUrl () {
      this.commands.link({href: this.form.url})
      this.closeLinkDialog()
    },
    unsetLinkUrl () {
      this.commands.link({href: null})
      this.closeLinkDialog()
    }
  },
  render () {
    return this.$scopedSlots.default({
      // Data
      form: this.form,
      isLinkDialogOpen: this.isLinkDialogOpen,
      isMoreTextFormattingOptionsVisible: this.isMoreTextFormattingOptionsVisible,
      // Computed
      textFormattingOptions: this.textFormattingOptions,
      moreTextFormattingOptions: this.moreTextFormattingOptions,
      // Methods
      formatText: this.formatText,
      isTextFormattingOptionActive: this.isTextFormattingOptionActive,
      isMoreTextFormattingOptionsActive: this.isMoreTextFormattingOptionsActive,
      setLinkUrl: this.setLinkUrl,
      unsetLinkUrl: this.unsetLinkUrl
    })
  }
}
